import { deleteApi, getApi, patchApi, postApi } from "./apiService"

export const addFaq = async (body) => {
    return await postApi("/mp/faq/create", body)
}

export const updateFaq = async (body) => {
    return await patchApi("/mp/faq/update", body)
}

export const deleteFaq = async (id) => {
    return await deleteApi(`/mp/faq/delete/${id}`)
}
export const getFaqbySort = async () => {
    return await getApi("/mp/faq/get-by-sort")
}